import React from "react";
import CoursesTable from "./CoursesTable";
import SeminarsTable from "./SeminarsTable";
import InstructorsTable from "./InstructorsTable";
import NeedingFollowupTable from "./NeedingFollowupTable";
import NewStudentsPanel from "../Shared/NewStudents";

export default function DesktopDashboard({
  newStudents,
  needingFollowup,
  courses,
  seminars,
  instructors,
  isAdmin,
  isGlobalAdmin,
  getNewStudents,
  hasHeadAdminRole,
  user,
}) {
  const followUpSlots = isGlobalAdmin
    ? 3
    : newStudents?.length > 0
      ? isAdmin
        ? 2
        : 1
      : isAdmin
        ? 3
        : 2;

  return (
    <>
      <h1 className="text-[32px]">My Dashboard</h1>
      <div className="flex mt-2">
        <div className="mr-4 w-1/2">
          {!isGlobalAdmin && (
            <NewStudentsPanel
              newStudents={newStudents}
              onChange={getNewStudents}
              user={user}
              type={hasHeadAdminRole ? "interest" : "student"}
              height={[425, 300]}
            />
          )}
          <NeedingFollowupTable
            needingFollowup={needingFollowup}
            slots={followUpSlots}
          />
        </div>
        <div className="w-1/2">
          <CoursesTable courses={courses} isAdmin={isAdmin} />
          <SeminarsTable seminars={seminars} isAdmin={isAdmin} />
          {isAdmin && <InstructorsTable instructors={instructors} />}
        </div>
      </div>
    </>
  );
}
